import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { QcReportDetailDTO, EurofinsControlParamsDTO } from './qcReportmodel';
import { ActivatedRoute } from '@angular/router';
import { QcreportDetailService } from './qcreport-detail.service';
import { QCReportProcessingRequest, Action } from '../qualityreport-list/models/QCReportProcessingRequest';
import { ReactionSetDetails } from './reactionSetDetails';
import { SelectItem } from 'primeng/api';
import { AuthenticationService } from '../common-services/authentication.service';


@Component({
  selector: 'app-qcreport-detail',
  templateUrl: './qcreport-detail.component.html',
  styleUrls: ['./qcreport-detail.component.css']
})
export class QcreportDetailComponent implements OnInit {

  controlClols: any[];
  @Input()qcReportDetail: QcReportDetailDTO;
  @Input()eurofinsControl: EurofinsControlParamsDTO[] ;
  @Input()id: string;

  @Output() backButtonEmitter = new EventEmitter();

  errorHandler: ErrorHandler = new ErrorHandler;
  isReadIdentifier: string = 'readIdentifier';
  comment: string;
  action = Action;
  qcReportProcessingRequest = {} as QCReportProcessingRequest;
  showPlateView: boolean = false;
  mapOfWellPositionAndQCInformation : any;
  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];

  rowHeadersOdd = ['A', 'C', 'E', 'G', 'I', 'K', 'M', 'O'];
  rowHeadersEven = ['B', 'D', 'F', 'H', 'J', 'L', 'N', 'P'];

  columnHeadersOdd = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23];
  columnHeadersEven = [2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];

  reactionSetInfo: ReactionSetDetails[];

  orderIdOptions: SelectItem[];
  PrimerNameOptions: SelectItem[];

  selectedPrimerName: string;
  selectedOrderID : string;

  disablePrimerNameDropdown : boolean = false;
  premixProduct : boolean = false;
  display : boolean = false
  displayLogin: boolean
  userAction: Action
  user: any = {};

  constructor(private http: HttpClient, private messagesService: MessagesService,
    private route: ActivatedRoute, private qcreportDetailService: QcreportDetailService,
    private authService: AuthenticationService
  ) { }

  ngOnInit() {
    this.comment = '';
    this.disablePrimerNameDropdown = false;
    this.controlClols = [
      { field: 'control', header: 'Control' },
      { field: 'status', header: 'Status' },
      { field: 'usedPrimer', header: 'Primer Used' },
      { field: 'guessPrimer', header: 'Guessed' },
      { field: 'match', header: 'Match' },
      { field: 'range', header: 'Range' },
      { field: 'length', header: 'Length' },
    ];
    this.userAction = null
  }

  login(action: Action) {
    this.displayLogin = true
    this.userAction = action
  }

  removeCredentials() {
    this.user = {}
  }


  takeActionAfterLogin(action: Action){
    this.authService.login(this.user.username, this.user.password)
        .subscribe(
        data => {                    
          this.setAction(this.userAction)
          this.displayLogin = false
          this.user = {} 
        },
        error => {
          if (error.status === 401) {
            this.messagesService.addErrorMessage({ severity: 'error', summary: 'Authentication failed', detail: 'Wrong username or password' });                       
            this.displayLogin = false
          } else{
            let message = this.errorHandler.handleError(error);
            this.messagesService.addErrorMessage(message); 
            this.displayLogin = false
          }  
          this.userAction = null
          this.user = {} 
        });
  }

  setAction(action: Action) {
    this.display = true
    this.qcReportProcessingRequest.id = this.id;
    this.qcReportProcessingRequest.action = action;
    this.qcReportProcessingRequest.comment = this.comment;
    this.comment = '';
    this.qcReportProcessingRequest.reportIdentifier = this.qcReportDetail.reportIdentifier;
    this.qcReportProcessingRequest.labIdentifier = this.qcReportDetail.labIdentifier;
    this.qcReportProcessingRequest.plateName = this.qcReportDetail.plateName;
    this.qcReportProcessingRequest.plateQCStatus = this.qcReportDetail.plateQCStatus.toString();
    this.qcReportProcessingRequest.plateQCComment = this.qcReportDetail.plateQCComment;
    this.qcReportProcessingRequest.approvalMessageLocation = this.qcReportDetail.approvalMessageLocation;

    this.qcreportDetailService.updateQcReportDetail(this.qcReportProcessingRequest).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.messagesService.addSuccessMessage({ severity: 'success', summary: ' QC report status updated', detail: 'Selected QC Report  status updated successful' });
        console.log('updated selected QC report status');
        this.backButtonEmitter.emit(false);
        this.userAction = null
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this.messagesService.addErrorMessage(message);
        this.backButtonEmitter.emit(false);
        this.userAction = null
      }
    );

  }

  //used to not display the buttons if action is already taken
  isActionTaken() {
    if (this.qcReportDetail != null  && this.qcReportDetail.action != null &&
      (this.qcReportDetail.action === Action.RELEASED || this.qcReportDetail.action === Action.TRASHED)) {
      return true;
    }
    return false;
  }

  is1QC(){
    if(this.qcReportDetail != null  && this.qcReportDetail.reportType != null && this.qcReportDetail.reportType === '1QC'){
      return true;
    }return false;
  }

  //Closes the dialog on click on back button
  onBackClick() {
  this.comment = '';
  this.showPlateView = false;
    this.backButtonEmitter.emit(false);
  }

  getreactionSetDetails(row: string, column: number) {
    let  position =  row + column;
    let a;
    if (this.reactionSetInfo && this.reactionSetInfo.length !== 0 ) {
      this.reactionSetInfo.forEach(element => {
        if (position === element.positionInReactionPlate) {
         a =  element;
        }
      });
    }
    return a;
    }

  viewPlate() {
    this.showPlateView = !this.showPlateView;
    //Call back-end only when plate view enabled
    if(this.showPlateView){
      this.orderIdOptions = [];
      this.PrimerNameOptions = [];
      this.orderIdOptions.push({'label':'None','value':'None'});
      this.PrimerNameOptions.push({'label':'None','value':'None'});
      this.selectedPrimerName = 'None';
      this.selectedOrderID = 'None';
      this.getAndCombineReactionInfoAndReportInfo();
      this.disablePrimerNameDropdown = false;     
    }
  }

  getAndCombineReactionInfoAndReportInfo() {
      this.qcreportDetailService.getReactionSetInformationForPlate(this.qcReportDetail.plateName).subscribe(
        results => {
          if (!results) {
            return;
          }
          this.reactionSetInfo = [];
          this.reactionSetInfo = results.data;
          let reactionSetDetails = results.data;
          let orderids = new Set();
          let primerNames = new Set();
          reactionSetDetails.forEach(element => {
              let rsinfo = new ReactionSetDetails();
              rsinfo.sampleBarcode = element.sampleBarcode;
              rsinfo.positionInReactionPlate = element.positionInReactionPlate;
              rsinfo.primerName = element.primerName;
              rsinfo.primerType = element.primerType;
              rsinfo.sampleName = element.sampleName;
              rsinfo.orderID = element.orderID;
              rsinfo.redoCount = element.redoCount;
              rsinfo.originalBarcode = element.originalBarcode;
              if( element.sampleName && element.sampleName.toLowerCase().includes('eurofins') ){
                rsinfo.originalBarcode = 'QC';
              }
              this.premixProduct = element.premixProduct;
              orderids.add(element.orderID);
              primerNames.add(element.primerName);
              Object.entries(this.qcReportDetail.mapOfPositionAndReportDetails).forEach(([key, value]) => {
                if (key === element.positionInReactionPlate) {
                  let reportValuesFromMap = <ReactionSetDetails> value;

                  rsinfo.QCcomment = reportValuesFromMap.QCcomment;
                  rsinfo.readLength = 'CRL:' + reportValuesFromMap.readLength;
                }
              });
            this.reactionSetInfo.push(rsinfo);
            }
         );
        Array.from(orderids).forEach(element => {
          if(element){
          this.orderIdOptions.push({'label':element,'value': element});
          }
        });
        if(this.premixProduct){
          this.disablePrimerNameDropdown = true;
        }else{
          Array.from(primerNames).forEach(element => {
            this.PrimerNameOptions.push({'label':element,'value': element});
          });
        }
        },
        error => {
          this.showPlateView = false;
          let message = this.errorHandler.handleError(error);
          this.messagesService.addErrorMessage(message);
        }
      );

  }

  getQuadrand() {
    let plateName = this.qcReportDetail.plateName;
    let indexOfUnderscore = plateName.indexOf('_');

    let quads = ['Q1', 'Q2', 'Q3', 'Q4'];

    let quadrant = plateName.substring(indexOfUnderscore + 1 , indexOfUnderscore + 3);
      if (quads.includes(quadrant)) {
      return quadrant;
    } else {
      return '';
    }
  }

  isSynthesized(row: string, column: number) {
    let  position =  row + column;
    let flag: boolean;
    if (this.reactionSetInfo && this.reactionSetInfo.length !== 0 ) {
      this.reactionSetInfo.forEach(element => {
        if (element && element.positionInReactionPlate && position === element.positionInReactionPlate) {
         if (element.primerType && element.primerType === 'ToBeSynthesized' ) {
           flag = true;
          }
        }
      });
    }
    return flag;
  }

  isEnclosed(row: string, column: number) {
    let  position =  row + column;
    let flag: boolean;
    if (this.reactionSetInfo && this.reactionSetInfo.length !== 0 ) {
      this.reactionSetInfo.forEach(element => {
        if (element && element.positionInReactionPlate && position === element.positionInReactionPlate) {
         if (element.primerType && element.primerType.valueOf() === 'Enclosed'.valueOf() ) {
           flag = true;
          }
        }
      });
    }
    return flag;
  }

  isStandard(row: string, column: number) {
    let  position =  row + column;
    let flag: boolean;
    if (this.reactionSetInfo && this.reactionSetInfo.length !== 0 ) {
      this.reactionSetInfo.forEach(element => {
        if (element && element.positionInReactionPlate && position === element.positionInReactionPlate) {
         if (element.primerType && element.primerType.valueOf() === 'Standard'.valueOf() ) {
           flag = true;
          }
        }
      });
    }
    return flag;
  }
  isPassed(row: string, column: number) {
    let position =  row + column;
    let flag: boolean;
    if (this.reactionSetInfo && this.reactionSetInfo.length !== 0 ) {
      this.reactionSetInfo.forEach(element => {
        if (element && element.positionInReactionPlate && position === element.positionInReactionPlate) {
         if ( element.QCcomment && element.QCcomment.toLowerCase().includes('passed') ) {
           flag = true;
          }
        }
      });
    }
    return flag;
  }
  isFailed(row: string, column: number) {
    let position =  row + column;
    let flag: boolean;
    if (this.reactionSetInfo && this.reactionSetInfo.length !== 0 ) {
      this.reactionSetInfo.forEach(element => {
        if (element && element.positionInReactionPlate && position === element.positionInReactionPlate) {
         if ( element.QCcomment && element.QCcomment.toLowerCase().includes('failed') ) {
           flag = true;
          }
        }
      });
    }
    return flag;
  }

  showSelectedPrimers(selectedPrimer){
    if(selectedPrimer.value != 'None'){
      this.selectedOrderID = 'None';
    }
  }


  showSelectedorders(selectedOrder){
    if(this.premixProduct){
      this.disablePrimerNameDropdown = true;
    }
    else if(selectedOrder.value != 'None'){
      this.selectedPrimerName = 'None' ;
    }
    else {
      this.selectedPrimerName = 'None' ;
    }
  }


  isFiltered(row: string, column: number){
    let position =  row + column;
    let flag: boolean;
    if (this.reactionSetInfo && this.reactionSetInfo.length !== 0 ) {
      this.reactionSetInfo.forEach(element => {
        if (element && element.positionInReactionPlate && position === element.positionInReactionPlate) {
          if((this.selectedOrderID != 'None' &&  element.orderID  != this.selectedOrderID )|| 
          (this.selectedPrimerName != 'None' && element.primerName  != this.selectedPrimerName )){
            flag = true;
          }
        }
      });
    }
    return flag;
  }

  isRedo(row: string, column: number) {
    let position =  row + column;
    let flag: boolean;
    if (this.reactionSetInfo && this.reactionSetInfo.length !== 0 ) {
      this.reactionSetInfo.forEach(element => {
        if (element && element.positionInReactionPlate && position === element.positionInReactionPlate) {
         if ( element.redoCount > 0 ) {
           flag = true;
          }
        }
      });
    }
    return flag;
  }
}
